var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mt-2",staticStyle:{"height":"86vh"}},[_c('iframe',{staticStyle:{"position":"absolute","height":"100%","border":"none"},attrs:{"src":"./manual/index.html","width":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }